import { render, staticRenderFns } from "./new-message.vue?vue&type=template&id=93fa6080&scoped=true"
import script from "./new-message.vue?vue&type=script&lang=js"
export * from "./new-message.vue?vue&type=script&lang=js"
import style0 from "./new-message.vue?vue&type=style&index=0&id=93fa6080&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93fa6080",
  null
  
)

export default component.exports